import React, { useState, useEffect } from 'react'
import sha256 from 'js-sha256'
import axios from 'axios'
import {format} from 'date-fns'
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import CreditUsagesModal from '../modalPopups/creditUsages';
import LoadingSpinner from './Spinner'
import OverlayLoader from '../modalPopups/overlayLoader'

export default function CreditSection(props) {

  const navigate = useNavigate();
  
  const hash = sha256(props.searchterm);
	const accessToken = localStorage.getItem("accessToken");

  let CreditUrl = `${process.env.REACT_APP_CSAPI_BASE_URL}/customer-profile?hash=${hash}&includeCredits=true&includeCreditsLog=true`;

  let addCreditsUrl = `${process.env.REACT_APP_CSAPI_BASE_URL}/credits/add?hash=${hash}`;
  let deductCreditsUrl = `${process.env.REACT_APP_CSAPI_BASE_URL}/credits/deduct?hash=${hash}`;

  const [addCreditNum, setAddCreditNum] = useState('');
  const [deductCreditNum, setDeductCreditNum] = useState('');
  const [creditsResultStatus, setCreditsResultStatus] = useState(false);
  const [creditsBalance, setCreditsBalance] = useState(0.00);
  const [creditData, setCreditData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [addDeductResultStatus, setAddDeductResultStatus] = useState('');
  const [buttonStatus, setbuttonStatus] = useState(true);
  const [overLayPopupShow, setOverLayPopupShow] = useState(false);
  const [overLayPopupText, setOverLayPopupText] = useState('');

  const [creditUsageInput, setCreditUsageInput] = useState({
    show: false,
    title: '',
    body: '',
    dataCreditUsages: []
	})

  const handleOverylayModalShowClose = (modalStatus,modalText) => {
    setOverLayPopupShow(modalStatus);
    setOverLayPopupText(modalText)
  }
    
  
  const fetchUrl = (URl) => {
		axios.get(URl, {				
			headers: {
				'Authorization': `Bearer ${accessToken}`
			},
		})
		.then(result => {
			//console.log("status"+result.data.status)
      setCreditsResultStatus(true)
      setIsLoading(false)
      handleOverylayModalShowClose(false,'')
			if(result.data.status === 'success')
			{
        setbuttonStatus(false)
        if(result.data.data.creditsPurchased.length > 0)
        {
          setCreditsResultStatus(false);
        }
        setCreditData(result.data.data.creditsPurchased);
        setCreditsBalance(result.data.data.creditsBalance)
			}
		})
		.catch((error) => {
			// Error
      handleOverylayModalShowClose(false,'')
			if(error.response.status === 401)
			{
				localStorage.clear()
      	navigate("/login")
			}
		});
	}

  const fetchUrlAddCredit = (URl, postData) => {
		axios.post(URl, postData, {				
			headers: {
				'Authorization': `Bearer ${accessToken}`
			},
		})
		.then(result => {			
			if(result.data.status === 'success')
			{
        setAddDeductResultStatus(`${addCreditNum} credit(s) has been added`)
        //setCreditsBalance(parseFloat(parseFloat(creditsBalance) + parseFloat(addCreditNum)).toFixed(2));
        setTimeout(() => {
          setAddDeductResultStatus();
          setIsLoading(true);
		      fetchUrl(CreditUrl);// eslint-disable-next-line
        }, 2000);
			}
		})
		.catch((error) => {
			// Error
			if(error.response.status === 401)
			{
				localStorage.clear()
      	navigate("/login")
			}
		});
	}

  const fetchUrlDeductCredit = (URl, postData) => {
		axios.post(URl, postData, {				
			headers: {
				'Authorization': `Bearer ${accessToken}`
			},
		})
		.then(result => {			
			if(result.data.status === 'success')
			{
        setAddDeductResultStatus(`${deductCreditNum} credit(s) has been deducted`)        
        setTimeout(() => {
          setAddDeductResultStatus()
          setIsLoading(true)
		      fetchUrl(CreditUrl);// eslint-disable-next-line
        }, 2000);
			}
		})
		.catch((error) => {
			// Error
			if(error.response.status === 401)
			{
				localStorage.clear()
      	navigate("/login")
			}
		});
	}

  const handleAddCredit = event => {
    setAddCreditNum(event.target.value);   
  };

  const handleAddCreditSubmit = event => {    
    const addCreditsPostData = {credits: addCreditNum};

    if(addCreditNum > 0)
    {
      setbuttonStatus(true)
      fetchUrlAddCredit(addCreditsUrl,addCreditsPostData);
    }
    
  };


  const handleDeductCredit = event => {
    setDeductCreditNum(event.target.value);   
  };


  const handleDeductCreditSubmit = event => {    
    const deductCreditsPostData = {credits: deductCreditNum};
    if(deductCreditNum > 0)
    {
      setbuttonStatus(true)
      fetchUrlDeductCredit(deductCreditsUrl,deductCreditsPostData);
    }
  };

  useEffect(() => {
    setbuttonStatus(true)
    setIsLoading(true)
    handleOverylayModalShowClose(true,'Credits Data Loading... Please Wait')
		fetchUrl(CreditUrl);// eslint-disable-next-line
	}, []);


  const getCreditStatus = (status) => {
      if (status === 'active') {
          return 'success';
      }
      else if (status === 'expired') {
          return 'danger';
      }
      else if (status === 'refunded') {
        return 'info';
      }
      else if (status === 'used') {
        return 'secondary';
      }
      else if (status === 'agentActivity') {
        return 'dark';
      }
      else {
        return 'light';
      }
  }
  
  const handleModalShow = (creditUsages) => {    

    setCreditUsageInput({
      show: true,
      title: 'Credit Usage',
      body: '',
      dataCreditUsages: creditUsages
    });
  };

  const handleModalClose = (fromModal) => {
    //alert(fromModal.msg);
    setCreditUsageInput({
      show: false,
      dataCreditUsages: []
    });
  };

  

  return (
    <>
        <div className="app-wrapper">
          <div className="app-content pt-3 p-md-3 p-lg-4">
              <div className="container-xl">

                  <OverlayLoader
                      show={overLayPopupShow}
                      title=''
                      body={overLayPopupText}
                  />
                  <div className="app-content pt-3 mb-5">
                    {props.searchterm ? (
                      <h3>
                        Search: <code>{props.searchterm}</code>
                      </h3>
                    ) : (
                      <h3>There is no name in the query string</h3>
                    )}                
                  </div>

                  <h1 className="app-page-title mb-0">Credits</h1>
                  <hr className="mb-4" />
                  <div className="app-card shadow-sm mb-4 border-left-decoration">
                    <div className="inner">
                      <div className="app-card-body p-4">
                        <div className="row gx-5 gy-3">
                            <div className="col-12 col-lg-9">
                              <h3 className='text-primary'>Total Credits: {creditsBalance}</h3>
                          </div>
                          
                        </div>            
                      </div>                        
                    </div>
                  </div>
                  {addDeductResultStatus &&
                      <div className="col-md-7 alert alert-success alert-dismissible fade show" role="alert">
                          {addDeductResultStatus}
                      </div>
                  }
                  <div className="row gy-4 pt-3">
                    <div className="col-12 col-lg-3">
                      <div className="input-group mb-3">
                        <input type="number" className="form-control" placeholder="0" aria-label="Add Credits" aria-describedby="button-addon2"
                          min="1" 
                          id="addcredit" 
                          name="addcredit" 
                          onChange={handleAddCredit}
                          value={addCreditNum}
                          disabled={buttonStatus}
                        />
                        <button className="btn btn-warning" type="button" id="button-addon2" onClick={handleAddCreditSubmit}>Add Credits</button>
                      </div>
                    </div>
                    <div className="col-12 col-lg-3 ms-5">
                      <div className="input-group mb-3">
                        <input type="number" className="form-control" placeholder="0" aria-label="Deduct Credits" aria-describedby="button-addon3"
                            min="1"
                            id="deductcredit" 
                            name="deductcredit" 
                            onChange={handleDeductCredit}
                            value={deductCreditNum}
                            disabled={buttonStatus}
                        />
                        <button className="btn btn-warning" type="button" id="button-addon3" onClick={handleDeductCreditSubmit}>Deduct Credits</button>
                      </div>
                    </div>
                  </div>


                  <hr className="mb-4" />

                  {creditsResultStatus ? (
										<div className="alert alert-danger fade show ms-3">
											Credits Data Not Found
										</div>									
									) : (

                    

                      <div className="app-card app-card-orders-table mb-5">
                          <div className="app-card-body">
                              <div className="table-responsive">
                                  <table className="table table-hover table-bordered border-success">
                                      <thead>
                                          <tr>
                                              <th className="cell">Credits Given</th>
                                              <th className="cell">Credit Used</th>
                                              <th className="cell">Date of Add</th>
                                              <th className="cell">Date of Expire</th>
                                              <th className="cell">Status</th>
                                              <th className="cell">Description</th> 
                                              <th className="cell">View Usage</th>                                             
                                          </tr>
                                      </thead>
                                      <tbody>
                                      {isLoading ? <tr><td colSpan={7}><LoadingSpinner loadingText='Fetching Credits Details' /></td></tr> : ''}                                      

                                      {creditData && creditData.map((creditResults, i) => {

                                        //totalPurchase = (parseFloat(totalPurchase) + parseFloat(order.productInfo.price));

                                        let formattedPurchasedDate = format(new Date(creditResults.purchaseDateTime),"MMM dd, y hh:mm:ss")
                                        let formattedExpiredDate = format(new Date(creditResults.expireDateTime),"MMM dd, y")
                                        let creditStatus = getCreditStatus(creditResults.status)
                                        
                                        let creditUsages = (creditResults.usages.length > 0 ? creditResults.usages : []);

                                            return (
                                                <tr key={i}>
                                                    <td>{creditResults.creditsPurchased}</td>
                                                    <td>{creditResults.creditsUsed}</td>
                                                    <td>{formattedPurchasedDate}</td>
                                                    <td>{formattedExpiredDate}</td>
                                                    <td className='text-center'><span className={`text-capitalize badge bg-${creditStatus}`}>{creditResults.status}</span></td>
                                                    <td className="text-capitalize">{creditResults.description}</td>                                                    
                                                    <td className='text-center'>
                                                      {creditResults.usages.length > 0 && (
                                                        <Button 
                                                          variant="primary"
                                                          onClick={() => handleModalShow(creditUsages)}
                                                          size="sm"
                                                        >
                                                          View Usage
                                                        </Button>
                                                      )}
                                                    </td>
                                                </tr>
                                            )
                                        })

                                      }
                                      </tbody>
                                  </table>                                  
                              </div>
                          </div>
                      </div>
                  )}

                  <CreditUsagesModal
                    show={creditUsageInput.show}
                    title={creditUsageInput.title}
                    body={creditUsageInput.body}
                    dataCreditUsages={creditUsageInput.dataCreditUsages}
                    onClick={handleModalClose}
                    onHide={handleModalClose}
                  />
              </div>     
          </div>
      </div>
    </>
    )
}